import { UseMutationResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { setSelectionData } from './setSelectionData';

import { useTrackedMutation as useMutation } from '@ais-ui/performance-tracking';

interface SetSelectionDataParams {
  jobId: string;
  selections: any[];
  show: boolean;
  show_only_selected: boolean;
  show_sog_distribution: boolean;
  show_decimal_knots: boolean;
  ignore_sog_of_zero: boolean;
}

type FetchOverlayData = (jobId: string, hasZoomed: boolean) => void;

export const useSetSelectionData = (
  fetchOverlayData: FetchOverlayData
): UseMutationResult<string, Error, SetSelectionDataParams> => {
  const { dbSession } = useSession();

  return useMutation<string, Error, SetSelectionDataParams>(
    async ({
      jobId,
      selections,
      show = false,
      show_only_selected = false,
      show_sog_distribution = false,
      show_decimal_knots = false,
      ignore_sog_of_zero = false,
    }) => {
      if (!dbSession) {
        throw new Error('dbSession is not defined.');
      }

      const params = {
        selections: selections,
        show: show,
        show_only_selected: show_only_selected,
        show_sog_distribution: show_sog_distribution,
        show_decimal_knots: show_decimal_knots,
        ignore_sog_of_zero: ignore_sog_of_zero,
      };

      const result = await setSelectionData(
        dbSession,
        jobId,
        JSON.stringify(params)
      );
      return String(result);
    },
    {
      onSuccess: (data, variables) => {
        fetchOverlayData(variables.jobId, true);
      },
    }
  );
};
